// extracted by mini-css-extract-plugin
export default {"policyComponentTypeOptionText":"policy-component-configuration-tab__policy-component-type-option-text__BsOJP"};